import { isIsolatedCloud } from '@atlaskit/atlassian-context/is-isolated-cloud';

import { createResource } from '@townsquare/router/resources/createResource';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { isHomeDashboardExperienceEnabled } from '@townsquare/stat-sig/aem';

type DashboardExperienceResponse = {
	isOptedIn: boolean;
	isOptedInToAi: boolean;
};
export const dashboardExperienceResource: RouteResource<DashboardExperienceResponse> =
	createResource<DashboardExperienceResponse>({
		type: 'DASHBOARD_EXPERIENCE_STATUS',
		getKey: (_, resourceContext) => {
			if (!isHomeDashboardExperienceEnabled(() => !isIsolatedCloud())) {
				return 'ISOLATED_CLOUD';
			}
			const { workspace } = resourceContext as ResourceContext;
			if (!workspace) {
				// "no workspace" is a valid customer experience
				return 'NO_WORKSPACE';
			}
			const { activationId, cloudId } = workspace;
			return JSON.stringify({ activationId, cloudId });
		},
		getData: async (_, resourceContext) => {
			if (!isHomeDashboardExperienceEnabled(() => !isIsolatedCloud())) {
				return {
					isOptedIn: false,
					isOptedInToAi: false,
				};
			}
			const { workspace } = resourceContext as ResourceContext;
			if (!workspace) {
				// "no workspace" is a valid customer experience
				return {
					isOptedIn: false,
					isOptedInToAi: false,
				};
			}
			const { activationId, cloudId } = workspace;
			const response = await fetch(
				`/gateway/api/avp-platform/cloudId/${cloudId}/workspaceId/${activationId}/dashboard-experience-status`,
			);
			if (!response.ok) {
				return {
					isOptedIn: false,
					isOptedInToAi: false,
				};
			}
			const data = await response.json();
			return {
				isOptedIn: data.isOptedIn ?? false,
				isOptedInToAi: data.isOptedInToAi ?? false,
			};
		},
		maxAge: 60_000 * 5,
	});
